module.exports = __webpack_public_path__ + "img/07.c8932db3.jpg";